
import { defineComponent } from 'vue';
import useCapabilities from '@/resources/capabilities';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VLoader from '@/components/vendor/VLoader.vue';
import Media from '@/api/objects/Media';
import TheAdminResourcesShowModal
  from '@/views/administrator/resources/parts/TheAdminResourcesShowModal.vue';
import TheAdminResourcesUpload
  from '@/views/administrator/resources/parts/TheAdminResourcesUpload.vue';

export default defineComponent({
  // TODO: This could be refactored to be used for any role
  name: 'TheAdminResourcesGrid',
  components: {
    TheAdminResourcesUpload,
    TheAdminResourcesShowModal,
    VLoader,
    VButton,
  },
  props: {
    media: {
      type: Array,
      required: false,
    },
    status: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  data() {
    return {
      showAddMedia: false,
      modalToShow: null,
      currentMedia: null as null | Media,
    };
  },
  methods: {
    mediaConfirm() {
      this.showAddMedia = false;
      this.$emit('refresh-media');
    },
  },
});
